import { render, staticRenderFns } from "./GameResult.vue?vue&type=template&id=2494a0d4&scoped=true&"
import script from "./GameResult.vue?vue&type=script&lang=ts&"
export * from "./GameResult.vue?vue&type=script&lang=ts&"
import style0 from "./GameResult.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GameResult.vue?vue&type=style&index=1&id=2494a0d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2494a0d4",
  null
  
)

export default component.exports